import { type StoryblokAkeneoCategoryPageType } from '../../storyblok'

import { storyblokProductSearchFiltersParseBlocksToFilters } from './model/blocks-to-filters/storyblokProductSearchFiltersParseBlocksToFilters'
import { storyblokProductSearchFiltersParseFiltersToQueryString } from './model/filters-to-query/storyblokProductSearchFiltersParseFiltersToQueryString'
import { type StoryblokProductSearchFiltersType } from './model/StoryblokProductSearchFilters.types'

export const storyblokProductSearchFiltersGetQuery = ({
  defaultFilters,
  productSearchFilters,
}: {
  defaultFilters?: StoryblokProductSearchFiltersType
  productSearchFilters?: StoryblokAkeneoCategoryPageType['productSearchFilters']
}): string => {
  const filters = storyblokProductSearchFiltersParseBlocksToFilters(
    productSearchFilters,
    defaultFilters,
  )

  return storyblokProductSearchFiltersParseFiltersToQueryString(filters)
}
